export default "__VITE_ASSET__3b585348__"